import { lazy, Suspense, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";


import Index from "./jsx/index";
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";

import "./css/style.css";
import { readSchools } from "./store/actions/schoolActions";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const Login = lazy(() => import("./jsx/pages/Login"));


function App(props) {
    const dispatch = useDispatch();
    const location = useLocation();

    // restore session once
    useEffect(() => {
        checkAutoLogin(dispatch);
    }, [dispatch]);


    // 🔥 LOAD SCHOOL AFTER LOGIN
    useEffect(() => {
        if (props.isAuthenticated) {
            dispatch(readSchools());
        }
    }, [props.isAuthenticated, dispatch]);

    // 🚫 NOT logged in → auth routes only
    if (!props.isAuthenticated) {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/page-register" element={<SignUp />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </Suspense>
        );
    }

    // ✅ LOGGED IN but still on /login → redirect once
    if (location.pathname === "/login") {
        return <Navigate to="/dashboard" replace />;
    }

    // ✅ Logged in → full ERP app
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Index />
        </Suspense>
    );
}


const mapStateToProps = (state) => ({
    isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(App);
